<!-- Se abre en un modal desde la ficha del cliente, que ya pone el título -->
<div>
  <app-page-header
    [className]="'mb-3!'"
    [showCreateButton]="permissionAuth.canCreate('clientes')"
    [textButton]="'Cargar presupuesto'"
    (onCreateClick)="openCreateModal()"
  />

  <!-- Filtros -->
  <app-filters-container
    [hasData]="presupuestos.length > 0"
    [hasActiveFilters]="hasActiveFilters"
    [loading]="loading"
    (clearFilters)="clearFilters()"
  >
    <app-search-input
      label="Buscar"
      placeholder="Buscar por número, descripción o archivo..."
      [value]="filtros.busqueda"
      (searchChange)="onSearchChange($event)"
    />

    <app-filter-date
      label="Fecha desde"
      [value]="filtros.fecha_desde"
      (valueChange)="onFechaDesdeChange($event)"
    />

    <app-filter-date
      label="Fecha hasta"
      [value]="filtros.fecha_hasta"
      (valueChange)="onFechaHastaChange($event)"
    />
  </app-filters-container>

  <!-- Tabla -->
  <app-data-table
    [columns]="columns"
    [data]="presupuestos"
    [loading]="loading"
    [emptyTitle]="'No hay presupuestos cargados'"
    [emptySubtitle]="'Cargá el archivo del presupuesto con su fecha para que quede registrado acá'"
    (rowClick)="onRowClick($event)"
  >
    <ng-template appTableCell="presupuesto_nro" let-presupuesto>
      {{ presupuesto.presupuesto_nro || ('Presupuesto #' + presupuesto.id) }}
    </ng-template>

    <ng-template appTableCell="fecha" let-presupuesto>
      @if (presupuesto.fecha) {
        {{ presupuesto.fecha | date: 'dd/MM/yyyy' }}
      } @else {
        <span class="text-gray-400 dark:text-gray-500">Sin fecha</span>
      }
    </ng-template>

    <ng-template appTableCell="monto" let-presupuesto>
      @if (presupuesto.monto !== null) {
        {{ presupuesto.monto | number: '1.0-0' }} Gs
      } @else {
        <span class="text-gray-400 dark:text-gray-500">-</span>
      }
    </ng-template>

    <ng-template appTableCell="seguimiento" let-presupuesto>
      <div class="flex flex-col">
        <small class="text-gray-500 dark:text-gray-400">
          Envío: {{ presupuesto.fecha_envio ? (presupuesto.fecha_envio | date: 'dd/MM/yyyy') : 'Sin datos' }}
        </small>
        <small class="text-gray-500 dark:text-gray-400">
          Aceptación: {{ presupuesto.fecha_aceptacion ? (presupuesto.fecha_aceptacion | date: 'dd/MM/yyyy') : 'Sin datos' }}
        </small>
      </div>
    </ng-template>

    <ng-template appTableCell="archivo" let-presupuesto>
      @if (presupuesto.tiene_archivo) {
        <span class="line-clamp-2" [matTooltip]="presupuesto.archivo_nombre">
          {{ presupuesto.archivo_nombre }}
        </span>
      } @else {
        <span class="text-gray-400 dark:text-gray-500">Sin archivo</span>
      }
    </ng-template>

    <ng-template appTableCell="descripcion" let-presupuesto>
      @if (presupuesto.descripcion) {
        <span class="line-clamp-2" [matTooltip]="presupuesto.descripcion">{{ presupuesto.descripcion }}</span>
      } @else {
        <span class="text-gray-400 dark:text-gray-500">Sin descripción</span>
      }
    </ng-template>

    <ng-template appTableCell="acciones" let-presupuesto let-index="index">
      <div class="flex items-center gap-x-2.5">
        @if (presupuesto.tiene_archivo) {
          <button
            type="button"
            [disabled]="downloadingId === presupuesto.id"
            [matTooltip]="'Descargar presupuesto'"
            (click)="descargar(presupuesto, $event)"
          >
            <mat-icon class="dark:text-gray-400!">download</mat-icon>
          </button>
        }

        <button
          type="button"
          [matTooltip]="'Editar presupuesto'"
          (click)="openEditModal(presupuesto); $event.stopPropagation()"
        >
          <mat-icon class="dark:text-gray-400!">edit</mat-icon>
        </button>

        <app-delete-trigger *hasPermission="'clientes.registros:delete'"
          [title]="'Eliminar presupuesto'"
          [disabled]="deleting && (index === deletingIndex)"
          (clickDeleteEvent)="delete(presupuesto.id, index)"
        />
      </div>
    </ng-template>
  </app-data-table>

  <!-- Paginación -->
  <app-pagination
    [currentPage]="currentPage"
    [lastPage]="lastPage"
    [perPage]="perPage"
    [total]="total"
    (pageChange)="onPageChange($event)"
    (perPageChange)="onPerPageChange($event)"
  />
</div>
